import { filterMapObject } from './utils'
import type { Pomodoro } from './types'

export const pomsForDate = (
  pomodoros: Map<string, Pomodoro>,
  date: Date
): Map<string, Pomodoro> => {
  const dateAsString = [
    date.getFullYear(),
    date.getMonth() + 1,
    date.getDate(),
  ].join('-')

  const matchingPoms = filterMapObject(pomodoros, ([, entryData]) => {
    return entryData.date === dateAsString
  })

  return matchingPoms
}
